<template>
	<div>

		<div class="lt_bgi">
			<div class="title">
				气象信息
			</div>
			<div class="con">
				<div v-for="(item,index) in list" :key='index'>
					<div style="padding-left: 10px;">
						<img style="width: 60px;height: 52px;" :src="item.img" alt="" />
					</div>
					<div  style="padding-left: 30px;">
						<div class="con1">{{item.num}}</div>
						<div  class="con2">{{item.name}}</div>
					</div>
				</div>
			</div>
		</div>





	</div>
</template>

<script>
	import {
		weather_information
	} from "../../api/home.js";
	import {
		Message
	} from 'element-ui';
	export default {
		components: {},
		data() {
			return {
				list: []
			}
		},
		mounted() {
			this.get()
		},
		methods: {
			get() {
				weather_information().then((res) => {

					if (res.code == 0) {
						this.list = [{
							name: '温度',
							img: require('../assets/ltm/lt1.png'),
							num: res.data.temperature
						}, {
							name: '风速',
							img: require('../assets/ltm/lt2.png'),
							num: res.data.wind_speed
						}, {
							name: '风向',
							img: require('../assets/ltm/lt3.png'),
							num: res.data.wind_direction
						}, {
							name: 'CO₂浓度',
							img: require('../assets/ltm/lt4.png'),
							num: res.data.CO2
						}, {
							name: '湿度',
							img: require('../assets/ltm/lt5.png'),
							num: res.data.humidity
						}, {
							name: '降雨量',
							img: require('../assets/ltm/lt6.png'),
							num: res.data.precipitation
						}]

					} else {
						Message.error(res.msg)

					}

				})
			}
		}
	}
</script>

<style scoped lang="less">
	.lt_bgi {
		width: 28vw;
		height: 31vh;
		background-image: url(/src/assets/lt.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;

	}

	.title {

		font-family: Source Han Sans CN;
		font-weight: bolder;
		font-size: 18px;
		color: #FFFFFF;
		font-style: italic;
		background: linear-gradient(0deg, #B5FFDA 0%, #FFFFFF 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		position: absolute;
		left: 70px;
		top: 8px
	}

	.con {
		width: 88%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		position: absolute;
		top: 52px;
		// background-color: #fff;
		left: 40px;
	}

	.con>div {
		width: 45%;
		display: flex;
		
		margin-top: 6px;
		background-image: url(/src/assets/lts.png);
		border-radius: 2px;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		padding: 5px 6px 5px 6px;
		// margin-left: 20px;
	}
	.con1{
		font-family: PangMenZhengDao;
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
		text-align: center;
		padding-top: 5px;
	}
	.con2{
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 12px;
		color: #CCEFEC;
		text-align: center;
		margin-top: 4px;
	}
</style>